import React, { useState, DragEvent } from 'react';
import MapItemSelector from '../Map/MapItemSelector';
import SpellIcon from '../Icons/SpellIcon';
import { setDrag } from '../../reducers/drag/dragReducerActions';
import { shallowEqual, useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Rootstate } from '../../store';
import patterns from './spellPatterns';
import { GRID_SIZE } from '../Map/Grid';
import { ObjectId } from 'bson';
import Input from '../UI/Input';

const SpellSelectorPopup = () => {
    const [size, setSize] = useState(20);

    const { layer } = useSelector((state: Rootstate) => ({
        layer: state.map.mainLayer,
    }), shallowEqual);
    const dispatch = useDispatch();

    const startDraggingToken = (e: DragEvent<HTMLOrSVGElement>, pattern: string) => {
        e.preventDefault();

        const onDragEnd = () => {
            dispatch(setDrag(false));
            window.removeEventListener('mouseup', onDragEnd);
        };

        window.addEventListener('mouseup', onDragEnd);

        dispatch(setDrag(
            true,
            {
                type: 'move-spell',
                details: {
                    shape: {
                        xPos: 0,
                        yPos: 0,
                        _id: new ObjectId(),
                        shape: pattern === 'permanentCircle' ? 'circle' : 'square',
                        dm: layer === 'dm',
                        width: size,
                        height: size,
                        color: '#FF000080',
                        rotation: 0,
                    },
                    startX: e.clientX,
                    startY: e.clientY,
                    rotate: 0,
                },
            },
        ));
    };
    return (
        <div className="min-w-96 bg-mid-blue p-4 gap-2 rounded-2xl">
            <div className="bg-deep-blue p-5 rounded-2xl flex items-center gap-5">
                <div>
                    <label htmlFor="size" className="block mt-1 mb-1 text-xs font-medium">
                        Size (feet)
                    </label>
                    <Input
                        type="number"
                        id="size"
                        value={size}
                        onChange={(e) => {
                            setSize(parseInt(e.target.value));
                        }}
                        className={"w-24 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg"
                            + " focus:ring-blue-500 focus:border-blue-500 block p-2.5 bg-gray-700"
                            + " border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500"
                            + " focus:border-blue-500"}
                        placeholder="0"
                        required
                    />
                </div>
                <div className='flex items-start gap-y-0 gap-5'>
                    <div
                        draggable
                        onDragStart={(e) => startDraggingToken(e, 'permanentSquare')}
                    >
                        <svg
                            width={GRID_SIZE * 4}
                            height={GRID_SIZE * 4}
                        >
                            {patterns['permanentCube'](20)}
                        </svg>
                    </div>
                    <div
                        draggable
                        onDragStart={(e) => startDraggingToken(e, 'permanentCircle')}
                    >
                        <svg
                            width={GRID_SIZE * 4}
                            height={GRID_SIZE * 4}
                        >
                            {patterns['permanentCircle'](10)}
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    );
};

const SpellSelector = () => {


    const button = (
        <>
            <div className="pl-4 pr-4 ">
                <SpellIcon className="h-10" />
            </div>
        </>
    );



    const popup = (
        <SpellSelectorPopup />
    );

    return (
        <MapItemSelector
            button={button}
            popup={popup}
            id="spell-selector"
        />
    );
};

export default SpellSelector;

